<template>
  <div class="list-student-container">
    <div class="event-container-outer">
      <div class="event-header">
        <p>{{
          (listType == 'late') ? 'Tardy'
          : (listType == 'permission') ? 'Permission'
          : (listType == 'sick') ? 'Sick'
          : (listType == 'absent') ? 'Absent'
          : ''
        }}</p>
      </div>

      <div class="event-content">
        <div class="event-content-outer">
          <ag-grid-vue
            style="width: 100%; height: 400px;"
            class="ag-theme-alpine"
            :columnDefs="(listType === 'late') ? columnDefsLate : (listType === 'absent') ? columnDefsAbsent : columnDefsPermission"
            :rowData="listData"
            :defaultColDef="defaultColDef"
            :context="context"
            :rowSelection="rowSelection"
            @grid-ready="onGridReady"
            :animateRows="true"
            :pagination="true"
          />
        </div>
      </div>
    </div>
  </div>

  <vue-final-modal
    v-model="modalDetail" classes="flex justify-center items-center py-10 px-4" content-class="w-full max-w-md h-auto"
    :ssr="true" :lock-scroll="true" :hide-overlay="false" :click-to-close="false" :esc-to-close="true" :prevent-click="true" :attach="false" transition="vfm" overlay-transition="vfm" :z-index-auto="true" :z-index-base="1000" :z-index="false" :focus-retain="true" :focus-trap="false"
    :fit-parent="true" :drag="false" drag-selector="" :keep-changed-style="false" :resize="false" :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']" :min-width="250" :min-height="250" :max-width="Infinity" :max-height="Infinity"
  >
    <div class="modal-head pt-5 pb-5">
      <h1>{{ (listType == 'late') ? 'Details of tardy' : (listType == 'absent') ? 'Details of absent' : (listType == 'permission') ? 'Details of permission' : (listType == 'sick') ? 'Details of sick' : '' }}</h1>
      <jb-button class="btn-close-modal" :icon="mdiClose" @click="getDetail()" />
    </div>

    <div class="modal-all-event">
      <div class="all-event-container">
        <div class="detail-bio-container">
          <div class="detail-bio-list">
            <p>Name</p>
            <p>:</p>
            <p>{{ dataDetail.name }}</p>
          </div>

          <div class="detail-bio-list">
            <p>NIS</p>
            <p>:</p>
            <p>{{ dataDetail.nis }}</p>
          </div>

          <div class="detail-bio-list">
            <p>Class</p>
            <p>:</p>
            <p>{{ dataDetail.class_name }}</p>
          </div>

          <div class="detail-bio-list">
            <p>Department</p>
            <p>:</p>
            <p>{{ dataDetail.department_name }}</p>
          </div>

          <div class="detail-bio-list">
            <p>Total of {{ (listType == 'late') ? 'Tardy' : (listType == 'permission') ? 'Permission' : (listType == 'sick') ? 'Sick' : 'Absent' }}</p>
            <p>:</p>
            <p>{{ dataDetail.total }}</p>
          </div>
        </div>

        <div v-show="dataDetail?.detail" v-for="data in dataDetail?.detail" :key="data" class="all-event-list">
          <p v-if="(listType == 'late')">{{ dateFormat(data.date) }}, {{ data.reason }}</p>
          <p v-if="(listType == 'late')">{{ data.time_in }}</p>

          <p v-if="(listType == 'permission') || (listType == 'sick')">{{ data.reason }}</p>
          <p v-if="(listType == 'permission') || (listType == 'sick')">{{ dateFormat(data.date) }}</p>

          <p v-if="(listType == 'absent')">{{ dataDetail.name }} | {{ dataDetail.nis }}</p>
          <p v-if="(listType == 'absent')">{{ dateFormat(data.date) }}</p>
        </div>
      </div>
    </div>
  </vue-final-modal>
</template>

<script>
  /* eslint-disable */
  import { ref, reactive, onMounted, onUnmounted, watch, watchEffect, computed, nextTick } from 'vue'
  import { mdiClose } from '@mdi/js'
  import { AgGridVue } from 'ag-grid-vue3'
  import axios from 'axios'
  import dayjs from 'dayjs'
  import 'dayjs/locale/id'

  import JbButton from '@/components/JbButton'

  export default {
    components: {
      AgGridVue,
      JbButton
    },

    props: {
      listLoad: { type: Boolean, default: false },
      listType: { type: String, default: "" },
      listData: { type: Array, default: () => [] },
    },

    setup (props, { emit }) {
      // watchEffect(() => {
      //   console.log("cek lah ges", props.listData)
      // })

      const rowSelection = ref('multiple')

      const gridApi = ref(null)

      const onGridReady = (params) => {
        gridApi.value = params.api
        params.api.sizeColumnsToFit()
      }

      const context = {
        componentParent: {
          openTeacherDetail: (teacher) => {}
        }
      }

      const defaultColDef = {
        resizable: true,
        sortable: false,
        filter: false
      }


      const columnDefsLate = ref([
        {
          headerName: '#',
          valueGetter: 'node.rowIndex+1',
          minWidth: 60,
          maxWidth: 80,
          onCellClicked: params => getDetail(params.data),
        },
        {
          field: 'time_in',
          headerName: 'Check-in Time',
          sortable: true,
          filter: true,
          minWidth: 160,
          onCellClicked: params => getDetail(params.data),
        },
        {
          field: 'date',
          headerName: 'Date',
          sortable: true,
          filter: true,
          minWidth: 160,
          onCellClicked: params => getDetail(params.data),
        },
        {
          field: 'name',
          headerName: 'Student Name',
          sortable: true,
          filter: true,
          minWidth: 240,
          onCellClicked: params => getDetail(params.data),
        },
        {
          field: 'nis',
          headerName: 'NIS',
          sortable: true,
          filter: true,
          minWidth: 160,
          onCellClicked: params => getDetail(params.data),
        },
        {
          field: 'class_name',
          headerName: 'Class',
          sortable: true,
          filter: true,
          minWidth: 160,
          onCellClicked: params => getDetail(params.data),
        },
        {
          field: 'department_name',
          headerName: 'Department',
          sortable: true,
          filter: true,
          minWidth: 160,
          onCellClicked: params => getDetail(params.data),
        },
      ])

      const columnDefsPermission = ref([
        {
          headerName: '#',
          valueGetter: 'node.rowIndex+1',
          minWidth: 60,
          maxWidth: 80,
          onCellClicked: params => getDetail(params.data),
        },
        {
          field: 'name',
          headerName: 'Student Name',
          sortable: true,
          filter: true,
          minWidth: 240,
          onCellClicked: params => getDetail(params.data),
        },
        {
          field: 'nis',
          headerName: 'NIS',
          sortable: true,
          filter: true,
          minWidth: 160,
          onCellClicked: params => getDetail(params.data),
        },
        {
          field: 'class_name',
          headerName: 'Class',
          sortable: true,
          filter: true,
          minWidth: 160,
          onCellClicked: params => getDetail(params.data),
        },
        {
          field: 'department_name',
          headerName: 'Department',
          sortable: true,
          filter: true,
          minWidth: 160,
          onCellClicked: params => getDetail(params.data),
        },
        {
          field: 'date',
          headerName: 'Date',
          sortable: true,
          filter: true,
          minWidth: 160,
          onCellClicked: params => getDetail(params.data),
        },
        {
          field: 'reason',
          headerName: 'Reason',
          sortable: true,
          filter: true,
          minWidth: 160,
          onCellClicked: params => getDetail(params.data),
        }
      ])

      const columnDefsAbsent = ref([
        {
          headerName: '#',
          valueGetter: 'node.rowIndex+1',
          minWidth: 60,
          maxWidth: 80,
          onCellClicked: params => getDetail(params.data),
        },
        {
          field: 'name',
          headerName: 'Student Name',
          sortable: true,
          filter: true,
          minWidth: 240,
          onCellClicked: params => getDetail(params.data),
        },
        {
          field: 'nis',
          headerName: 'NIS',
          sortable: true,
          filter: true,
          minWidth: 160,
          onCellClicked: params => getDetail(params.data),
        },
        {
          field: 'class_name',
          headerName: 'Class',
          sortable: true,
          filter: true,
          minWidth: 160,
          onCellClicked: params => getDetail(params.data),
        },
        {
          field: 'department_name',
          headerName: 'Department',
          sortable: true,
          filter: true,
          minWidth: 160,
          onCellClicked: params => getDetail(params.data),
        },
        {
          field: 'date',
          headerName: 'Date',
          sortable: true,
          filter: true,
          minWidth: 160,
          onCellClicked: params => getDetail(params.data),
        },
      ])


      const modalDetail = ref(false)
      const dataDetail = ref({})
      const getDetail = (data) => {
        if(data) {
          dataDetail.value = data
          modalDetail.value = true
        } else {
          modalDetail.value = false
          dataDetail.value = ({})
        }
      }


      dayjs.locale('id')
      const dateFormat = (date1, date2 = null) => {
        const d1 = dayjs(date1)
        const d2 = date2 ? dayjs(date2) : null

        if (!d1.isValid()) return ''

        if (!d2 || !d2.isValid()) {
          return d1.format('D MMMM YYYY')
        }

        if (d1.isSame(d2, 'day')) {
          return d1.format('D MMMM YYYY')
        }

        const sameMonth = d1.isSame(d2, 'month')
        const sameYear = d1.isSame(d2, 'year')

        if (sameMonth && sameYear) {
          return `${d1.format('D')}-${d2.format('D MMMM YYYY')}`
        }

        if (!sameMonth && sameYear) {
          return `${d1.format('D MMM')} - ${d2.format('D MMM YYYY')}`
        }

        return `${d1.format('D MMM YYYY')} - ${d2.format('D MMM YYYY')}`
      }


      return {
        mdiClose,
        rowSelection,
        defaultColDef,
        context,
        gridApi,
        onGridReady,
        columnDefsLate,
        columnDefsPermission,
        columnDefsAbsent,
        modalDetail,
        dataDetail,
        getDetail,
        dateFormat
      }
    }
  }
</script>

<style lang="scss">
  .list-student-container {
    .event-container-outer {
      width: 100%;
      height: auto;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;

      .event-header {
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 16px;
        background-color: #152751;

        p {
          width: 100%;
          text-align: center;
          font-size: 16px;
          line-height: 24px;
          font-weight: 600;
          color: white;
        }
      }

      .event-content {
        width: 100%;
        height: fit-content !important;
        overflow-y: auto;
        background-color: white;

        .event-content-outer {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          gap: 8px;
          padding: 8px;
        }
      }
    }
  }

  .detail-bio-container {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 4px;
    border-bottom: 1px solid lightgray;
    padding: 20px 0;

    .detail-bio-list {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;

      p {
        width: 100%;

        &:nth-child(1) {
          font-size: 12px;
          line-height: 20px;
          font-weight: 500;
        }

        &:nth-child(2) {
          display: none;
        }

        &:nth-child(3) {
          font-weight: 600;
        }
      }

      @media (min-width: 520px) {
        flex-direction: row;
        align-items: center;

        p {
          font-size: 14px;
          line-height: 24px;

          &:nth-child(1) {
            width: 120px;
          }

          &:nth-child(2) {
            width: 10px;
            display: block;
          }

          &:nth-child(3) {
            width: calc(100% - 120px - 10px);
          }
        }
      }
    }
  }
</style>
